import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);
  const sid = sp.get("session_id");

  useEffect(() => {
    if (!sid) return;
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries >= 20) { setStatus("timeout"); return; }
        setTries((n) => n + 1);
        t = setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => clearTimeout(t);
  }, [sid, tries]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        <CheckCircle2 size={64} className={`mx-auto ${status === "paid" ? "text-emerald-500" : "text-slate-300"}`} />
        <h1 className="font-display text-3xl font-bold mt-4">
          {status === "paid" ? "Payment successful" : status === "timeout" ? "Still processing…" : "Confirming payment…"}
        </h1>
        <p className="text-slate-600 mt-2">
          {status === "paid" ? "Your booking is paid. Your provider will now schedule the work." : "This can take a few seconds — please wait."}
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/customer" className="btn-accent">Go to my bookings</Link>
          <button onClick={() => nav(-1)} className="btn-outline">Back</button>
        </div>
      </div>
    </div>
  );
}
